import React, { useState, useRef, Component } from 'react';
import { EmailSignature, EmailSignatureCompact } from './components/EmailSignature';
// Copy button component
function CopyButton({
  onClick,
  copied
}: {
  onClick: () => void;
  copied: boolean;
}) {
  return <button onClick={onClick} style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: copied ? '#00B5AD' : '#ffffff',
    color: copied ? '#ffffff' : '#00B5AD',
    border: `2px solid #00B5AD`,
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'Arial, sans-serif',
    whiteSpace: 'nowrap'
  }} onMouseEnter={e => {
    if (!copied) {
      e.currentTarget.style.backgroundColor = '#00B5AD';
      e.currentTarget.style.color = '#ffffff';
    }
  }} onMouseLeave={e => {
    if (!copied) {
      e.currentTarget.style.backgroundColor = '#ffffff';
      e.currentTarget.style.color = '#00B5AD';
    }
  }} data-id="element-0">
      {copied ? <>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1">
            <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2" />
          </svg>
          Copié !
        </> : <>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3">
            <rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor" strokeWidth="1.5" data-id="element-4" />
            <path d="M3 10.5V3C3 2.44772 3.44772 2 4 2H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-5" />
          </svg>
          Copier la signature
        </>}
    </button>;
}
type Person = 'dina' | 'naoufel' | 'randa' | 'mohamad' | 'majdi' | 'mehdi';
export function App() {
  const [selectedPerson, setSelectedPerson] = useState<Person>('naoufel');
  const [copiedStates, setCopiedStates] = useState<Record<string, boolean>>({});
  const signature1Ref = useRef<HTMLDivElement>(null);
  const signature2Ref = useRef<HTMLDivElement>(null);
  const signature3Ref = useRef<HTMLDivElement>(null);
  const signature4Ref = useRef<HTMLDivElement>(null);
  const signature5Ref = useRef<HTMLDivElement>(null);
  const signature6Ref = useRef<HTMLDivElement>(null);
  const signature7Ref = useRef<HTMLDivElement>(null);
  const signature8Ref = useRef<HTMLDivElement>(null);
  const signature9Ref = useRef<HTMLDivElement>(null);
  const signature10Ref = useRef<HTMLDivElement>(null);
  const signature11Ref = useRef<HTMLDivElement>(null);
  const signature12Ref = useRef<HTMLDivElement>(null);
  // Dina's signature data
  const signatureDataDina = {
    name: 'ANTAKLY Dina',
    title: 'Assistante de direction',
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99'
  };
  // Naoufel's signature data
  const signatureDataNaoufel = {
    name: 'GRISSA Naoufel',
    title: 'Ingénieur EPMI',
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99',
    mobile: '06.13.59.07.50'
  };
  // Randa's signature data
  const signatureDataRanda = {
    name: 'GRISSA Randa',
    title: 'Directrice Adjointe',
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99',
    mobile: '06.51.15.90.42'
  };
  // Mohamad's signature data
  const signatureDataMohamad = {
    name: 'FAKHREDDINE Mohamad',
    title: "Chargé d'affaires",
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99',
    mobile: '06.58.70.70.53'
  };
  // Majdi's signature data
  const signatureDataMajdi = {
    name: 'BOUGAMRA Majdi',
    title: "Chargé d'affaires",
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99',
    mobile: '06.23.74.33.11'
  };
  // Mehdi's signature data
  const signatureDataMehdi = {
    name: 'FATHALLAH Mehdi',
    title: 'Agent IT',
    address: ["Parc d'activités des EPINEAUX", '8 Avenue Eugène Freyssinet', '95740 Frépillon'],
    phone: '01.47.72.04.99',
    mobile: '07.53.29.34.19'
  };
  const copySignature = async (ref: React.RefObject<HTMLDivElement>, id: string) => {
    if (!ref.current) return;
    try {
      const signatureHTML = ref.current.innerHTML;
      // Create a blob with HTML content
      const htmlBlob = new Blob([signatureHTML], {
        type: 'text/html'
      });
      const textBlob = new Blob([signatureHTML], {
        type: 'text/plain'
      });
      // Use the Clipboard API to write both HTML and plain text
      await navigator.clipboard.write([new ClipboardItem({
        'text/html': htmlBlob,
        'text/plain': textBlob
      })]);
      // Show success state
      setCopiedStates(prev => ({
        ...prev,
        [id]: true
      }));
      // Reset after 2 seconds
      setTimeout(() => {
        setCopiedStates(prev => ({
          ...prev,
          [id]: false
        }));
      }, 2000);
    } catch (err) {
      console.error('Failed to copy signature:', err);
    }
  };
  const people = [{
    id: 'naoufel' as Person,
    name: 'GRISSA Naoufel'
  }, {
    id: 'randa' as Person,
    name: 'GRISSA Randa'
  }, {
    id: 'dina' as Person,
    name: 'ANTAKLY Dina'
  }, {
    id: 'mohamad' as Person,
    name: 'FAKHREDDINE Mohamad'
  }, {
    id: 'majdi' as Person,
    name: 'BOUGAMRA Majdi'
  }, {
    id: 'mehdi' as Person,
    name: 'FATHALLAH Mehdi'
  }];
  // Render signature section with responsive header
  const renderSignatureSection = (title: string, signatureRef: React.RefObject<HTMLDivElement>, signatureId: string, SignatureComponent: typeof EmailSignature | typeof EmailSignatureCompact, signatureData: any) => <div style={{
    marginBottom: '60px'
  }} data-id="element-6">
      <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      gap: '12px',
      flexWrap: 'wrap'
    }} data-id="element-7">
        <h2 style={{
        fontSize: '14px',
        color: '#999',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        margin: 0,
        flex: '1 1 auto',
        minWidth: '200px'
      }} data-id="element-8">
          {title}
        </h2>
        <CopyButton onClick={() => copySignature(signatureRef, signatureId)} copied={copiedStates[signatureId] || false} data-id="element-9" />
      </div>
      <div style={{
      backgroundColor: '#ffffff',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
    }} data-id="element-10">
        <div ref={signatureRef} data-id="element-11">
          <SignatureComponent {...signatureData} data-id="element-12" />
        </div>
      </div>
    </div>;
  return <div style={{
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif'
  }} data-id="element-13">
      <div style={{
      maxWidth: '800px',
      margin: '0 auto'
    }} data-id="element-14">
        {/* Header */}
        <div style={{
        marginBottom: '32px',
        textAlign: 'center'
      }} data-id="element-15">
          <h1 style={{
          fontSize: 'clamp(24px, 5vw, 28px)',
          color: '#00B5AD',
          marginBottom: '8px',
          fontWeight: '600'
        }} data-id="element-16">
            France Décoration
          </h1>
          <p style={{
          color: '#666',
          fontSize: 'clamp(14px, 3vw, 16px)',
          marginBottom: '0'
        }} data-id="element-17">
            Signatures Email Professionnelles
          </p>
        </div>

        {/* Person selector tabs */}
        <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '40px',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }} data-id="element-18">
          {people.map(person => <button key={person.id} onClick={() => setSelectedPerson(person.id)} style={{
          padding: 'clamp(10px, 2vw, 12px) clamp(16px, 3vw, 24px)',
          backgroundColor: selectedPerson === person.id ? '#00B5AD' : '#ffffff',
          color: selectedPerson === person.id ? '#ffffff' : '#333',
          border: selectedPerson === person.id ? '2px solid #00B5AD' : '2px solid #e0e0e0',
          borderRadius: '8px',
          fontSize: 'clamp(13px, 2.5vw, 15px)',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          fontFamily: 'Arial, sans-serif'
        }} onMouseEnter={e => {
          if (selectedPerson !== person.id) {
            e.currentTarget.style.borderColor = '#00B5AD';
            e.currentTarget.style.color = '#00B5AD';
          }
        }} onMouseLeave={e => {
          if (selectedPerson !== person.id) {
            e.currentTarget.style.borderColor = '#e0e0e0';
            e.currentTarget.style.color = '#333';
          }
        }} data-id="element-19">
              {person.name}
            </button>)}
        </div>

        {/* Dina's signatures */}
        {selectedPerson === 'dina' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature1Ref, 'sig1', EmailSignature, signatureDataDina)}
            {renderSignatureSection('Version Compacte', signature2Ref, 'sig2', EmailSignatureCompact, signatureDataDina)}
          </>}

        {/* Naoufel's signatures */}
        {selectedPerson === 'naoufel' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature3Ref, 'sig3', EmailSignature, signatureDataNaoufel)}
            {renderSignatureSection('Version Compacte', signature4Ref, 'sig4', EmailSignatureCompact, signatureDataNaoufel)}
          </>}

        {/* Randa's signatures */}
        {selectedPerson === 'randa' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature5Ref, 'sig5', EmailSignature, signatureDataRanda)}
            {renderSignatureSection('Version Compacte', signature6Ref, 'sig6', EmailSignatureCompact, signatureDataRanda)}
          </>}

        {/* Mohamad's signatures */}
        {selectedPerson === 'mohamad' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature7Ref, 'sig7', EmailSignature, signatureDataMohamad)}
            {renderSignatureSection('Version Compacte', signature8Ref, 'sig8', EmailSignatureCompact, signatureDataMohamad)}
          </>}

        {/* Majdi's signatures */}
        {selectedPerson === 'majdi' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature9Ref, 'sig9', EmailSignature, signatureDataMajdi)}
            {renderSignatureSection('Version Compacte', signature10Ref, 'sig10', EmailSignatureCompact, signatureDataMajdi)}
          </>}

        {/* Mehdi's signatures */}
        {selectedPerson === 'mehdi' && <>
            {renderSignatureSection('Version Complète avec Bordure Lotus', signature11Ref, 'sig11', EmailSignature, signatureDataMehdi)}
            {renderSignatureSection('Version Compacte', signature12Ref, 'sig12', EmailSignatureCompact, signatureDataMehdi)}
          </>}

        {/* Usage instructions */}
        <div style={{
        backgroundColor: '#ffffff',
        padding: 'clamp(20px, 4vw, 24px)',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }} data-id="element-20">
          <h3 style={{
          fontSize: 'clamp(15px, 3vw, 16px)',
          color: '#333',
          marginBottom: '12px'
        }} data-id="element-21">
            Instructions d'utilisation
          </h3>
          <ul style={{
          color: '#666',
          fontSize: 'clamp(13px, 2.5vw, 14px)',
          lineHeight: '1.8',
          paddingLeft: '20px',
          margin: 0
        }} data-id="element-22">
            <li data-id="element-23">Sélectionnez une personne dans les onglets ci-dessus</li>
            <li data-id="element-24">Cliquez sur "Copier la signature" pour copier le HTML</li>
            <li data-id="element-25">
              Collez-le dans les paramètres de signature de votre client email
            </li>
            <li data-id="element-26">Le logo animé s'affichera automatiquement</li>
            <li data-id="element-27">
              Compatible avec Outlook, Gmail, Apple Mail et autres clients
            </li>
          </ul>
        </div>
      </div>
    </div>;
}